import React from 'react'

const CourierRules = () => {
  return (
    <div>CourierRules</div>
  )
}

export default CourierRules